import { useMemo } from 'react';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import { fabricFallbackURL } from 'data-hooks/useProductCardSwatches/utils';
import constructFabricUrl from 'commons/constructFabricUrl';
import { GET_FABRIC_DATA } from 'mocks/queries';

const useFabricDetails = fabricId => {
  const { loading, error, data } = useSuspenseQuery(GET_FABRIC_DATA, {
    variables: { activeOnly: true },
  });

  const selectedFabric = useMemo(() => {
    if (!fabricId || !data?.getFabrics?.length) {
      return null;
    }
    const fabric = data.getFabrics.find(f => f.option_value_id === fabricId);
    if (fabric) {
      const optionImageUrl = fabricFallbackURL(fabric.option_image);
      const isFabric = fabric.option_name === 'Fabric';

      return {
        ...fabric,
        fabricURL: isFabric
          ? constructFabricUrl(fabric.option_value, null)
              ?.transparent_config_image
          : optionImageUrl,
        fabricFallbackURL: isFabric
          ? optionImageUrl
          : `https://joybird2.imgix.net/option_images/swatches/290x290-${fabric.option_image}`,
      };
    }
    return null;
  }, [fabricId, data]);

  return {
    loading,
    error,
    data: {
      selectedFabric,
    },
  };
};

export default useFabricDetails;
